export * from './video.component';
